import { render, staticRenderFns } from "./AnimatedLogo.vue?vue&type=template&id=dd60a39a&scoped=true&"
import script from "./AnimatedLogo.vue?vue&type=script&lang=js&"
export * from "./AnimatedLogo.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedLogo.vue?vue&type=style&index=0&id=dd60a39a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd60a39a",
  null
  
)

export default component.exports